import { Component, Output, EventEmitter, Input, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, ViewRef, Renderer2, NgZone, OnDestroy, ViewChildren, QueryList } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LpsConversionDetails } from 'src/app/models/lps-conversion-details';
import { CommonUtils } from 'src/app/utils/common-utils';

@Component({
  selector: 'conversion-details-panel',
  templateUrl: './conversion-details-panel.component.html',
  styleUrls: ['./conversion-details-panel.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ConversionDetailsPanelComponent implements AfterViewInit, OnDestroy {

  @Output() validationEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() conversionDetailsChange: EventEmitter<LpsConversionDetails> = new EventEmitter<LpsConversionDetails>();

  @ViewChildren('subProjectId,spectrumUrl,spectrumUserName,spectrumPassword,spectrumFolderName', {read: NgModel}) inputs: QueryList<NgModel>;

  private _fields: LpsConversionDetails;
  private convDetailsChangeSubscription: Subscription;
  private spectrumInstanceTypeChangeSubscription: Subscription;

  @Input('conversionDetails') 
  public get fields(): LpsConversionDetails { return this._fields; }
  public set fields(value: LpsConversionDetails) {
    if (this.convDetailsChangeSubscription) { this.convDetailsChangeSubscription.unsubscribe(); }
    if (this.spectrumInstanceTypeChangeSubscription) { this.spectrumInstanceTypeChangeSubscription.unsubscribe(); }
    this._fields = value;
    if (this._fields) {
      this.convDetailsChangeSubscription = this._fields.conversionDetailsChange.subscribe(() => {
        this.conversionDetailsChange.emit(this.fields);
        this.validateFields();
        this.detectChanges(); 
      });
      this.spectrumInstanceTypeChangeSubscription = this._fields.spectrumInstanceTypeChange.subscribe(() => { 
        this.resetTouchedFields(); 
        this.fields.resetConversionFieldsOnInstanceTypeChange();
      })
    }
    this.detectChanges();
  }

  constructor(private cdr: ChangeDetectorRef, private ngZone: NgZone, private renderer: Renderer2) { }

  public ngAfterViewInit(): void {
    if (this.fields === undefined) { 
      this.fields = new LpsConversionDetails(); 
      this.conversionDetailsChange.emit(this.fields);
    }
  }

  public ngOnDestroy(): void {
    if (this.convDetailsChangeSubscription) { this.convDetailsChangeSubscription.unsubscribe(); }
    if (this.spectrumInstanceTypeChangeSubscription) { this.spectrumInstanceTypeChangeSubscription.unsubscribe(); }
  }

  protected isTouched(field: HTMLElement) { return field !== undefined && field.classList.contains('ng-touched'); }

  private resetTouchedFields() {
    if (this.inputs) {
      this.inputs.forEach(currModel => {currModel.reset(currModel.value);});
    }
    this.detectChanges(true);
  }

  protected validateFields() {
    const isValid = this.fields ? this.fields.validateConversionFields() : false;
    this.validationEvent.emit(isValid);
  }

  protected filterPort(e: any) {
    const t: EventTarget = e.target;
    if (t instanceof HTMLInputElement) {
      t.value = t.value.replace(LpsConversionDetails.invalidPortCharsRegExp, '');
    }
  }

  protected filterSubProjectId(e: any) {
    const t: EventTarget = e.target;
    if (t instanceof HTMLInputElement) {
      t.value = t.value.replace(LpsConversionDetails.invalidProjectIdCharsRegExp, '');
    }
  }

  protected detectChanges(delay: boolean = false) { 
    if (delay === true) {
      CommonUtils.lwDelay(this, this.ngZone, () => { this.detectChanges(); })
    } else {
      if (this.cdr && !((this.cdr as ViewRef).destroyed)) { this.cdr.detectChanges(); }
    }
  }
}